
import {
  IonGrid,
  IonRow,
  IonCol,
  IonInput,
  IonCheckbox
} from '@ionic/vue';
import { defineComponent, onMounted, PropType, ref, Ref, toRef } from "vue";
import AutoFillSelect from '@/components/AutoFillSelect.vue';
import axiosInstance from "@/axiosInstance";
import frTranslations from '@/locales/fr.json';

export default defineComponent({
  name: "SalesCultureDataForm",
  components: {
    IonGrid,
    IonRow,
    IonCol,
    IonInput,
    IonCheckbox,
    AutoFillSelect
  },
  props: {
    companyId: {
      type: Number as PropType<number>,
      required: true,
    },
  },
  setup(props) {
    const currentLanguage = ref('fr');
    const translations = {
      fr: frTranslations,
    };
    const dataLoaded = ref(false);
    const companyId = toRef(props, 'companyId');
    const data = ref({});
    const soilTillageTypes = ref([]);
    const selectedSoilTillageType = ref<any>({});

    const submitForm = async () => {
      try {
        data.value = await updateData(companyId, data.value);
        dataLoaded.value = true;
      } catch (error) {
        console.error('Error updating production data:', error);
      }
    };

    onMounted(async () => {
      data.value = await getData(companyId);
      soilTillageTypes.value = await getSoilTillageTypes();
      dataLoaded.value = true;
    });

    const getData = async (companyId: Ref<number>) => {
      try {
        const response = await axiosInstance.get(`api/core/sales-culture-data/${companyId.value}/`);
        return response.data;
      } catch (error) {
        console.error(error);
        throw error;
      }
    };

    const getSoilTillageTypes = async () => {
      try {
        const response = await axiosInstance.get(`api/core/soil-tillage-types/`);
        return response.data;
      } catch (error) {
        console.error(error);
        return "";
      }
    };

    const updateData = async (companyId: Ref<number>, data: any) => {
      try {
        const response = await axiosInstance.put(`api/core/sales-culture-data/${companyId.value}/update/`, data);
        return response.data;
      } catch (error) {
        console.error(error);
        throw error;
      }
    };
    
    const handleSelected = (option: any, item: any, field: string, update = false) => {
      item[field] = option ? option.id : null;
      if (field == 'soil_tillage') {
        selectedSoilTillageType.value = option;
      }
      if (update) {
        updateData(companyId, item);
      }
    }

    return {
      translations,
      currentLanguage,
      data,
      soilTillageTypes,
      selectedSoilTillageType,
      submitForm,
      handleSelected
    };
  },
});
